import { React, useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useLocation } from "react-router-dom";
import Footer from "../components/layouts/footer";
import { getSharedCartFiles } from "../api/api";
import { useTranslation } from "react-i18next";
import logo from "../assets/img/beachcomber.png";
import { basename } from "../config";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { downloadItem, downloadFilesAsZip } from "../components/utilities";
import $ from "jquery";
import { Dialog } from "primereact/dialog";
import { term_and_condition } from "../components/constant";

export default function SharedCart() {
  const { t } = useTranslation();
  const [totalFiles, setTotalFiles] = useState(0);
  const [totalSize, setTotalSize] = useState(0);
  const [cartItems, setCartItems] = useState([]);
  const [hasAccepted, setHasAccepted] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const allParams = location.pathname.split("/").slice(2).join("/");
    const params = atob(allParams);

    const criteria = params.split("/");
    

    const getSharedCart = async (id, email) => {
      const response = await getSharedCartFiles(id, email);

      if (response) {
        setCartItems(response.files);
        setTotalSize(response.totalSize);
        setTotalFiles(response.totalFiles);
      }
    };

    if (criteria) {
      getSharedCart(criteria[0], criteria[1]);
    }
  }, []);

  const renderTooltip = (val) => {
    function toSnakeCase(str) {
      return str.replace(/\s+/g, "_").replace(/&/g, "and").toLowerCase();
    }

    let name = toSnakeCase(val);

    return (
      <Tooltip id={"button-tooltip-" + name} className="custom-tooltip ">
        {t(name)}
      </Tooltip>
    );
  };

  const downloadAll = (e) => {
    e.preventDefault();
    let filenames = [];
    let urls = [];

    if (!hasAccepted) {
      window.location.hash = "#terms-conditions"; 
      setIsValid(false);
      
      return false;
    }
    if (cartItems.length === 0) {
      return;
    }

    urls = cartItems.map((item) => item.filePath);
    filenames = cartItems.map((item) => item.name);

    downloadFilesAsZip(filenames, urls);
  };

  const acceptTerm = () => {
    $("#terms-conditions").attr("checked", true);
    setHasAccepted(!hasAccepted);
    setIsValid(true);
    setVisible(false);
  };

  const showTermsAndCondition = (e) => {
    e.preventDefault();
    setVisible(true);
  };

  const customMenu = (item) => {
    return (
      <>
        <div className="row g-2 cart-action-icon">
          <div className="col-12 col-sm-6 col-md-6 col-lg-6">
            <OverlayTrigger
              placement={"top"}
              delay={{ show: 50, hide: 50 }}
              overlay={renderTooltip("Download")}
            >
              <a
                href="/"
                className=""
                key={"download-" + item.name}
                onClick={(e) => downloadItem(e, item)}
              >
                <i className="bi bi-download"></i>
              </a>
            </OverlayTrigger>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="">
      <div className=" ">
        <Row>
          <div className="sticky-top shared-cart">
            <div className=" text-center ">
              <div className="">
                <a href={'/'}>
                  <img alt="beachcomber logo" src={logo} className="logo" />
                </a>
              </div>

              <div className="">
                <p className="mb-1">{t("welcome_to_the_website")}</p>
                <h3 className="app-title text-muted ">
                  BEACHCOMBER<span className="bcb-primary-color">B2B</span>
                </h3>
                <p className="text-capitalize">{t("website")}</p>
              </div>

              <div className="p-2 d-flex justify-content-center">
                <hr className="w-80" />
              </div>
            </div>
          </div>

          <div className="text-center my-3">
            <h2 className="bcb-text-primary">View my cart</h2>
            <p>Find the contents of your cart</p>
            <h4 className="text-muted">
              Items in your cart: {totalFiles} File size: {totalSize.toFixed(2)}{" "}
              MB
            </h4>
          </div>
          <div>
            <Row>
              <div className="row mt-2">
                <div className="col-12 col-sm-2 col-md-2 col-lg-2"></div>
                <div className="col-12 col-sm-8 col-md-8 col-lg-8">
                  {cartItems.length > 0 ? (
                    <ul className="custom-list">
                      {cartItems.map((item, index) => (
                        <li key={"element-" + index}>
                          <div className="row g-2 py-4">
                            <div className="col-12 col-sm-11">
                              <div className="row g-3">
                                <div className="col-12 col-sm-auto"></div>
                                <div className="col-12 col-sm-2">
                                  <div>
                                    <img
                                      src={item.src}
                                      alt="Factsheet"
                                      className="cart-img"
                                    />
                                  </div>
                                </div>
                                <div className="col-12 col-lg-9">
                                  <div>
                                    <h5>
                                      {item.category} | {item.name} -{" "}
                                      {item.category} - {item.date}
                                    </h5>
                                    <p>
                                      {t("language")} :{" "}
                                      <span className="text-uppercase">
                                        {item.language}
                                      </span>{" "}
                                      | {t("file_type")} :{" "}
                                      <span className="text-uppercase">
                                        {item.type}
                                      </span>
                                    </p>
                                    <div className="filesize">
                                      {t("file_size")} : {item.size}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col col-sm-1 d-flex align-items-end">
                              {customMenu(item)}
                            </div>
                          </div>
                        </li>
                      ))}
                      <div className="text-center mt-2" >
                            <input
                              type="checkbox"
                              id="terms-conditions"
                              name="termsAndCondition"
                              checked={hasAccepted ? true : false}
                              onChange={() => acceptTerm()}
                              className="me-3"
                            />
                            <label htmlFor="terms-conditions">
                              {t("accept_the")}
                              <span className="">
                                {" "}
                                <a
                                  href="/"
                                  className="custom-a bcb-text-primary"
                                  onClick={(e) => showTermsAndCondition(e)}
                                >
                                  {t("terms_and_conditions")}
                                </a>
                              </span>
                            </label>
                            <p
                              className={
                                !isValid ? " size-small text-red " : " h "
                              }
                            >
                              {t("you_must_terms_and_conditions")}
                            </p>
                          </div>
                    </ul>
                  ) : (
                    <div>
                      <p className="text-center p-4 fs-1 text-muted fw-light">
                        {t("your_cart_has_expired")}
                      </p>
                    </div>
                  )}
                  <div className="row sticky-bottom shared-cart-download">
                    <div className="col d-flex justify-content-center mt-4">
                      {cartItems.length > 0 ? (
                        
                        <div className="">
        
                          <div className=" cart-btn-group">
                            <div className=" ">
                              <button
                                type="button"
                                onClick={(e) => downloadAll(e)}
                                className="col-12  btn bcb-btn bcb-btn-primary text-uppercase bcb-btn-small d-flex justify-content-between px-3 "
                              >
                                <span className="mt-1 text-bold">
                                  {t("download_all")}
                                </span>

                                <i className="bi bi-download"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-2 col-md-2 col-lg-2"></div>
              </div>
            </Row>
            <Dialog
              header={t("terms_and_conditions")}
              visible={visible}
              style={{ width: "50vw" }}
              onHide={() => setVisible(false)}
            >
              <p className="m-0 fst-italic">{term_and_condition}</p>
              <div className=" mt-4 text-center">
                <hr />
                <button
                  type="button"
                  onClick={() => acceptTerm()}
                  className="btn bcb-btn bcb-btn-primary text-uppercase bcb-btn-small  "
                >
                  {t("accept")}
                </button>
                <button
                  type="button"
                  onClick={() => setVisible(false)}
                  className="btn bcb-btn bcb-btn-secondary  text-uppercase bcb-btn-small mx-3"
                >
                  {t("decline")}
                </button>
              </div>
            </Dialog>
          </div>
        </Row>
        <div>
          <Footer islogin={true} />
        </div>
      </div>
    </div>
  );
}
